import { render, staticRenderFns } from "./partenaire.vue?vue&type=template&id=33700e6a&scoped=true&"
import script from "./partenaire.vue?vue&type=script&lang=js&"
export * from "./partenaire.vue?vue&type=script&lang=js&"
import style0 from "./partenaire.vue?vue&type=style&index=0&id=33700e6a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33700e6a",
  null
  
)

/* custom blocks */
import block0 from "./partenaire.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,LittleFaq: require('/app/components/LittleFaq.vue').default,NetworkForm: require('/app/components/NetworkForm.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
